import axios, { AxiosError, AxiosResponse } from 'axios'

// 使用 process.env 而不是 import.meta.env (适用于 CRA)
const BACKEND_HOST = process.env.REACT_APP_BACKEND_HOST 

export const instance = axios.create({
  baseURL: `${BACKEND_HOST}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Add response interceptor to handle errors
instance.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    // Laravel验证错误处理（422状态码）
    if (error.response?.status === 422) {
      // 转换Laravel验证错误格式为前端格式
      const laravelErrors =
        error.response.data && typeof error.response.data === 'object'
          ? (error.response.data as any).errors || {}
          : {}

      // Laravel默认验证返回errors: { field: ['error message'] }
      // 确保它能被我们的前端正确处理
      if (error.response.data && typeof error.response.data === 'object') {
        error.response.data = {
          ...(error.response.data as object),
          errors: laravelErrors,
        }
      }

      return Promise.reject(error)
    }

    // 处理401 - 认证错误（密码不正确等）
    if (error.response?.status === 401) {
      // 未授权，可能是 token 过期，清除 token
      // Cookies.remove('token')
      
      // 如果不是登录页面，则重定向到登录页
      if (window.location.pathname !== '/auth/login') {
        window.location.href = '/auth/login'
      }
    }

    // Handle other errors
    return Promise.reject(error)
  }
)

export const responseBody = (response: AxiosResponse) => response.data

export const requests = {
  get: (url: string, params?: Record<string, any>) =>
    instance.get(url, params).then(responseBody),
  post: (url: string, body: {}, options?: Record<string, any>) =>
    instance.post(url, body, options).then(responseBody),
  put: (url: string, body: {}) => instance.put(url, body).then(responseBody),
  patch: (url: string, body: {}) =>
    instance.patch(url, body).then(responseBody),
  delete: (url: string) => instance.delete(url).then(responseBody),
}
